import { render, staticRenderFns } from "./normal_inq.vue?vue&type=template&id=51abf99f&scoped=true"
import script from "./normal_inq.vue?vue&type=script&lang=js"
export * from "./normal_inq.vue?vue&type=script&lang=js"
import style0 from "./normal_inq.vue?vue&type=style&index=0&id=51abf99f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51abf99f",
  null
  
)

export default component.exports